import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "#151D20"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0767 18.0923V16.7385C17.0767 16.0203 16.8092 15.3317 16.3332 14.8239C15.8572 14.3161 15.2115 14.0308 14.5382 14.0308H9.4613C8.7881 14.0308 8.1424 14.3161 7.66635 14.8239C7.1903 15.3317 6.92285 16.0203 6.92285 16.7385V18.0923M11.9996 11.3231C13.4016 11.3231 14.5381 10.1108 14.5381 8.61544C14.5381 7.11999 13.4016 5.90771 11.9996 5.90771C10.5977 5.90771 9.46124 7.11999 9.46124 8.61544C9.46124 10.1108 10.5977 11.3231 11.9996 11.3231Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
